import type { PlanBenefits } from '../../types/planBenefits';
import type { PromoCampaign } from './types';

const isInPeriod = (campaign: PromoCampaign, nowMs: number): boolean =>
  Date.parse(campaign.period.startDate) <= nowMs &&
  nowMs < Date.parse(campaign.period.endDate);

/** Campanha ativa para o plano e o período, ainda sem o filtro de face mínima (use getActivePromoForFace para um valor específico). Sem hora do servidor, null. */
export function getActivePromo(
  campaign: PromoCampaign | null | undefined,
  planBenefits: PlanBenefits | null | undefined,
  nowMs: number | null,
): PromoCampaign | null {
  if (!campaign || nowMs === null || !planBenefits?.category) return null;

  return campaign.conditions.category === planBenefits.category &&
    isInPeriod(campaign, nowMs)
    ? campaign
    : null;
}

/** Campanha ativa para uma face específica (id em centavos). */
export function getActivePromoForFace(
  campaign: PromoCampaign | null | undefined,
  planBenefits: PlanBenefits | null | undefined,
  faceId: number,
  nowMs: number | null,
): PromoCampaign | null {
  const active = getActivePromo(campaign, planBenefits, nowMs);
  if (!active || faceId < active.conditions.minFace) return null;
  return active;
}

/** Hora do servidor a partir da diferença de relógio guardada na store (null sem serverDate). */
export const getServerNow = (
  serverTimeOffsetMs: number | null,
): number | null =>
  serverTimeOffsetMs === null ? null : Date.now() + serverTimeOffsetMs;
